import { FlaskConical, Leaf, Stethoscope, ShieldCheck } from "lucide-react";
import { Reveal, Label } from "./motion";

const PILLARS = [
  { icon: FlaskConical, title: "Third-Party Lab Focus", body: "A concept built around independent COA testing for potency & purity.", testid: "cbdoodle-lab-test-badge" },
  { icon: Leaf, title: "Organic, Clean Hemp", body: "Broad-spectrum, non-GMO hemp — no unnecessary fillers or additives." },
  { icon: Stethoscope, title: "Vet-Guided Approach", body: "Designed to be discussed with your veterinarian, not a replacement for them." },
  { icon: ShieldCheck, title: "Low-THC & Non-Intoxicating", body: "Formulated to stay under 0.3% THC, keeping seniors safe and comfortable." },
];

export const Trust = () => (
  <section id="quality" data-testid="cbdoodle-trust-section" className="bg-[#F3EDE2] px-5 py-20 sm:px-8 lg:py-28">
    <div className="mx-auto max-w-7xl">
      <div className="mx-auto max-w-2xl text-center">
        <Reveal><Label>Quality &amp; Safety</Label></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-4 font-serif text-3xl font-semibold leading-tight text-[#2C2B29] sm:text-4xl lg:text-[2.9rem]">
            Built on transparency and trust
          </h2>
        </Reveal>
      </div>

      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {PILLARS.map((p, i) => {
          const Icon = p.icon;
          return (
            <Reveal key={p.title} delay={i * 0.08} data-testid={p.testid}>
              <div className="group h-full rounded-[1.5rem] border border-[#E6E0D4] bg-[#FFFDF9] p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl">
                <div className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-[#E2ECE7] text-[#4A6B5D] transition-colors group-hover:bg-[#C58F3B] group-hover:text-white">
                  <Icon size={22} />
                </div>
                <h3 className="font-serif text-lg font-semibold text-[#2C2B29]">{p.title}</h3>
                <p className="mt-2 font-sans text-sm leading-relaxed text-[#5C5850]">{p.body}</p>
              </div>
            </Reveal>
          );
        })}
      </div>

      <Reveal delay={0.2}>
        <div
          data-testid="cbdoodle-disclaimer-note"
          className="mx-auto mt-12 max-w-3xl rounded-2xl border border-[#C58F3B]/30 bg-[#FDF6E7] px-6 py-5 text-center"
        >
          <p className="font-sans text-sm leading-relaxed text-[#7a5c22]">
            <strong>Not a substitute for veterinary care.</strong> CBDoodle is a concept showcase and supports
            comfort, mobility, and calm — it is not intended to diagnose, treat, cure, or prevent any disease.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
